import { render, staticRenderFns } from "./Editar-Cardapio.vue?vue&type=template&id=2396115a&"
import script from "./Editar-Cardapio.vue?vue&type=script&lang=js&"
export * from "./Editar-Cardapio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editar-Cardapio.vue"
export default component.exports